import type { MouseEvent } from "react";
import { toast } from "sonner";
import apiClient from "../api/client";
import { errorMessage } from "./error-message";

// Bu yollar admin bearer token'ı ister; düz <a href> Authorization başlığı gönderemez.
const PROTECTED_PREFIXES = ["/api/jobs/cv/", "/api/dealers/file/"];

/** Korumalı API dosyasıysa istek yolunu (path+query) döner, değilse null (ör. presigned URL). */
export function protectedApiPath(url: string): string | null {
  let parsed: URL;
  try {
    parsed = new URL(url, window.location.origin);
  } catch {
    return null;
  }
  return PROTECTED_PREFIXES.some((p) => parsed.pathname.startsWith(p))
    ? parsed.pathname + parsed.search
    : null;
}

export async function downloadProtectedFile(path: string): Promise<void> {
  const res = await apiClient.get<Blob>(path, { responseType: "blob" });
  const objectUrl = URL.createObjectURL(res.data);
  try {
    const a = document.createElement("a");
    a.href = objectUrl;
    a.download = decodeURIComponent(path.split("?")[0].split("/").pop() || "dosya");
    document.body.appendChild(a);
    a.click();
    a.remove();
  } finally {
    // click() indirmeyi eşzamanlı başlatır; bir sonraki tick'te bırakmak güvenli.
    setTimeout(() => URL.revokeObjectURL(objectUrl), 0);
  }
}

/** <a href={url} onClick={protectedFileClick(url)}>: korumalı yolu token'lı indirir, diğerlerini olduğu gibi açar. */
export function protectedFileClick(url: string) {
  return (e: MouseEvent<HTMLAnchorElement>) => {
    const path = protectedApiPath(url);
    if (!path) return;
    e.preventDefault();
    downloadProtectedFile(path).catch((err: unknown) => {
      toast.error(errorMessage(err, "Dosya indirilemedi"));
    });
  };
}
